<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<h2 class="text-primary" style="margin-bottom: 0px">
					<i class="fas fa-box" /> Estoque
				</h2>
				<small class="text-muted"
					>Controle e realize movimentações no seu estoque.</small
				>
			</div>

			<div
				class="col-md-6 text-right"
				v-if="this.$store.getters.userPermissionStockTransactionCreateEdit"
			>
				<button
					class="btn btn-success mr-2"
					style="margin-left: 5px"
					@click="$refs.form.open()"
				>
					<i class="fas fa-plus" /> Novo Lançamento
				</button>


				<b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <b-dropdown-item @click="printStockAudit()">
						<i class="fas fa-print mr-2"/>Inventário de Estoque
          </b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-item  to="/compras/novo">
						<i class="fas fa-file-import" /> Importar Xml
					</b-dropdown-item>
        </b-dropdown>
			</div>
		</div>

		<br />

		<hr />

		<div class="row">
			<div class="col-md-4">
				<text-input
					:alias="'Pesquisar'"
					v-model="searchForm.description"
				></text-input>
			</div>
			<div class="col-md-4 d-flex align-items-end">
				<div class="form-group">
					<button type="button" class="btn btn-sm btn-primary" @click="select">
						<i class="fas fa-search" /> Pesquisar
					</button>
				</div>
			</div>
		</div>

		<br />

		<div class="row">
			<div class="col-md-12">
				<table-paginator :data="stockTransactions" @pagechange="select($event)">
					<div class="row grid-table-heading">
						<div class="col-md-4">Produto</div>
						<div class="col-md-2 text-right">Data</div>
						<div class="col-md-2 text-right">Quantidade</div>
						<div class="col-md-2 text-right">Saldo</div>
						<div class="col-md-1 text-center">Status</div>
						<div class="col-md-1 text-center"></div>
					</div>
					<hr />
					<div
						class="row grid-table-row"
						v-for="(row, index) in stockTransactions.data"
						:key="index"
					>
						<div class="col-md-4">
							<span
								class="fa-stack"
								:title="origin[row.origin].text"
								@click="redirect(row.order_id)"
							>
								<i class="fas fa-circle fa-stack-2x text-muted"></i>
								<i
									:class="[origin[row.origin].icon, 'fa-stack-1x fa-inverse']"
								></i>
							</span>
							{{ row.description }}
							<small class="text-muted"> #{{ row.base_sku_id }}</small>
						</div>
						<div class="col-md-2 text-right">
							{{ row.date | dateBr }}
						</div>
						<div class="col-md-2 text-right">
							{{ row.quantity | decimal(3) }}
						</div>
						<div class="col-md-2 text-right">
							<span v-if="row.status != 'c'">{{
								row.balance | decimal(3)
							}}</span>
						</div>
						<div class="col-md-1 text-center">
							<span :class="['badge', 'text-white', status[row.status].class]">
								{{ status[row.status].text }}
							</span>
						</div>
						<div class="col-md-1 text-center">
							<b-dropdown
								variant="light"
								right
								toggle-class="text-decoration-none ml-3"
								no-caret
							>
								<template v-slot:button-content>
									<i class="fas fa-ellipsis-v text-muted" />
								</template>
								<b-dropdown-item
									v-if="stockTransactionCancel"
									@click.stop="cancel(row.id)"
								>
									<i class="fas fa-ban text-danger" />
									Cancelar
								</b-dropdown-item>
							</b-dropdown>
						</div>
					</div>
				</table-paginator>
			</div>
		</div>

		<error-handler :error="error" />

		<stock-transaction-form ref="form" @stored="select" />
	</div>
</template>

<script>
	import StockTransactionForm from "./../components/forms/StockTransactionForm.vue";
	import TablePaginator from "./../components/sections/TablePaginator.vue";

	export default {
		components: {
			StockTransactionForm,
			TablePaginator,
		},

		data: function () {
			return {
				stockTransactions: {},

				searchForm: {
					description: null,
				},

				origin: {
					o: {
						text: "Vendas",
						icon: "fas fa-shopping-cart",
					},
					c: {
						text: "Lançamento",
						icon: "fas fa-pen",
					},
				},

				status: {
					p: {
						text: "Processado",
						class: "badge-success",
					},
					c: {
						text: "Cancelado",
						class: "badge-danger",
					},
				},
				currentPage: 1,
				error: null,
			};
		},

		created() {
			axios
				.post("api/stock/select", this.searchForm)
				.then((response) => {
					this.stockTransactions = response.data;

					this.$store.commit("pageHasLoaded");
				})
				.catch((error) => {
					this.error = error;
					this.$store.commit("pageHasLoadedWithError", { error: error });
				});
		},

		computed: {
			canCancelStock() {
				return this.$store.getters.userPermissionStockTransactionCancel;
			},
			stockTransactionCancel() {
				return this.$acl.can('stockTransactionCancel')
			},
      purchaseCreateEdit() {
				return this.$acl.can('purchaseCreateEdit')
			},
		},

		methods: {
			redirect(orderId) {
				if (orderId) {
					this.$router.push("vendas/editar/" + orderId);
				}
			},

			select(page = 1) {
				this.currentPage = page;
				this.$store.commit("showLoading");
				axios
					.post("api/stock/select?page=" + this.currentPage, this.searchForm)
					.then((response) => {
						this.stockTransactions = response.data;

						this.$store.commit("hideLoading");
					})
					.catch((error) => {
						this.error = error;

						this.$store.commit("hideLoading");
					});
			},

			cancel(id) {
				this.$store.commit("showLoading");
				axios
					.post("api/stocktransaction/cancel/" + id)
					.then((response) => {
						this.select(this.currentPage);

						this.$store.commit("hideLoading");
					})
					.catch((error) => {
						this.error = error;
						this.$store.commit("hideLoading");
					});
			},
			printStockAudit(){
				window.open('/estoque/inventario')
			}
		},
	};
</script>

